import type { FAQItem } from '@/types';

export const FAQ_ITEMS: FAQItem[] = [
  {
    question: '联脉的数据来源是什么？',
    answer: '联脉仅使用公开数据源，包括企业官网、公开社交媒体、行业数据库等。我们严格遵守数据隐私法规，不使用任何非公开或未经授权的数据。',
  },
  {
    question: '如何确保外联的合规性？',
    answer: '我们建立了完整的合规体系：仅使用公开数据、提供拒联名录功能、实施频控机制、全链路审计日志。同时，我们提供合规培训和外联模板，帮助您的团队遵守各地区的数据保护法规。',
  },
  {
    question: '可以与现有的 CRM 系统集成吗？',
    answer: '是的，联脉支持与主流 CRM、ATS 系统集成，包括 Salesforce、HubSpot、钉钉、企业微信等。我们也提供开放 API，方便您自定义集成方案。',
  },
  {
    question: '如何开始使用联脉？',
    answer: '您可以通过页面上的表单预约 Demo，我们的顾问会在 24 小时内与您联系。根据您的业务场景，我们会提供定制化的解决方案和试用计划。',
  },
];
